import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import { Button, Col, Divider, Flex, Radio, Row, Space, Typography } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
const CertQuickSearch = ({ data, radioData, name, onClickFun }) => {
    var _a, _b;
    const [collapse, setCollapse] = useState(false);
    const [selectedOption, setSelectedOption] = useState(radioData && radioData.length > 0 ? (_b = (_a = radioData[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.key : null);
    const [highlightedButton, setHighlightedButton] = useState(null);
    // Move the setValue call to useEffect to avoid render-time updates
    useEffect(() => {
        var _a;
        if (selectedOption !== null && selectedOption !== undefined) {
            const selectedRadio = radioData === null || radioData === void 0 ? void 0 : radioData.find((item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.key) === selectedOption; });
            if ((_a = selectedRadio === null || selectedRadio === void 0 ? void 0 : selectedRadio.data) === null || _a === void 0 ? void 0 : _a.setValue) {
                selectedRadio.data.setValue(selectedOption);
            }
        }
    }, [selectedOption, radioData]);
    // Initialize the highlighted button
    useEffect(() => {
        var _a, _b;
        if (data && data.length > 0) {
            const firstButtonKey = (_b = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.key;
            setHighlightedButton(firstButtonKey);
        }
    }, [data]);
    const handleButtonClick = useCallback((key) => {
        setHighlightedButton(key);
    }, []);
    const handleOptionChange = useCallback((e) => {
        const selectedKey = e.target.value;
        setSelectedOption(selectedKey);
        handleButtonClick(selectedKey);
    }, [handleButtonClick]);
    const toggleCollapse = useCallback(() => {
        setCollapse(prev => !prev);
    }, []);
    const handleButtonAction = useCallback((button) => {
        var _a;
        if ((_a = button === null || button === void 0 ? void 0 : button.data) === null || _a === void 0 ? void 0 : _a.setValue) {
            button.data.setValue(button.data.key);
        }
        handleButtonClick(button.data.key);
        if (onClickFun) {
            onClickFun();
        }
    }, [handleButtonClick, onClickFun]);
    return (_jsxs(Space, { style: { width: '100%' }, direction: "vertical", children: [_jsxs(Flex, { align: "center", justify: "space-between", children: [_jsx(Typography.Text, { strong: true, children: "Filter By Quick Search" }), collapse ? (_jsx(PlusOutlined, { onClick: toggleCollapse })) : (_jsx(MinusOutlined, { onClick: toggleCollapse }))] }), !collapse && (_jsx(Space, { direction: "vertical", style: { width: '100%' }, children: _jsxs("div", { children: [_jsx("div", { style: { marginBottom: '20px' }, children: _jsx(Radio.Group, { onChange: handleOptionChange, value: selectedOption, style: { display: 'block' }, children: _jsx("div", { style: { marginBottom: '8px' }, children: radioData === null || radioData === void 0 ? void 0 : radioData.map((obj) => {
                                        var _a, _b, _c;
                                        return (_jsx("div", { children: _jsx(Radio, { value: (_a = obj === null || obj === void 0 ? void 0 : obj.data) === null || _a === void 0 ? void 0 : _a.key, children: (_b = obj === null || obj === void 0 ? void 0 : obj.data) === null || _b === void 0 ? void 0 : _b.title }) }, (_c = obj === null || obj === void 0 ? void 0 : obj.data) === null || _c === void 0 ? void 0 : _c.key));
                                    }) }) }) }), _jsx(Row, { gutter: [16, 16], children: data === null || data === void 0 ? void 0 : data.map((button) => {
                                var _a, _b, _c;
                                return (_jsx(Col, { span: 12, children: _jsx(Button, { block: true, style: {
                                            backgroundColor: 'transparent',
                                            color: '#000',
                                            border: highlightedButton === ((_a = button === null || button === void 0 ? void 0 : button.data) === null || _a === void 0 ? void 0 : _a.key)
                                                ? '2px solid #000'
                                                : '2px solid #ccc',
                                            fontWeight: highlightedButton === ((_b = button === null || button === void 0 ? void 0 : button.data) === null || _b === void 0 ? void 0 : _b.key) ? 'bold' : 'normal'
                                        }, onClick: () => handleButtonAction(button), children: button.data.title }) }, (_c = button === null || button === void 0 ? void 0 : button.data) === null || _c === void 0 ? void 0 : _c.key));
                            }) })] }) })), _jsx(Divider, {})] }));
};
export default CertQuickSearch;
